export default __webpack_public_path__ + "static/media/image-work-personal-w.4fc72e83.png";